"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _Blog = _interopRequireDefault(require("settings-ui-sdk/Blogs/Blog"));

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIMultiColumn = _interopRequireDefault(require("UIComponents/layout/UIMultiColumn"));

var _UIMultiColumnGroup = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnGroup"));

var _UIMultiColumnItem = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnItem"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UsageTracker = require("settings-ui-app/utils/UsageTracker");

var buttonLangKey = function buttonLangKey(key) {
  return "marketing.blog.buttonLabels." + key;
};

var BlogSettingsHeader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(BlogSettingsHeader, _PureComponent);

  function BlogSettingsHeader() {
    (0, _classCallCheck2.default)(this, BlogSettingsHeader);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BlogSettingsHeader).apply(this, arguments));
  }

  (0, _createClass2.default)(BlogSettingsHeader, [{
    key: "renderBlogControls",
    value: function renderBlogControls() {
      var moreThanOneBlog = this.props.moreThanOneBlog;

      if (moreThanOneBlog) {
        return this.renderMultipleBlogControls();
      }

      return this.renderSingularBlogControls();
    }
  }, {
    key: "renderDeleteButton",
    value: function renderDeleteButton() {
      return _react.default.createElement(_UIButton.default, {
        "data-test-id": "delete-blog-btn",
        use: "link-danger",
        size: "small",
        onClick: this.props.onDeleteBlog,
        disabled: this.props.readOnly
      }, _react.default.createElement(_FormattedMessage.default, {
        message: buttonLangKey('deleteBlog')
      }));
    }
  }, {
    key: "renderViewBlogLink",
    value: function renderViewBlogLink() {
      return _react.default.createElement(_UILink.default, {
        external: true,
        href: this.props.selectedBlog.get('absoluteUrl'),
        className: "m-right-3",
        onClick: function onClick() {
          (0, _UsageTracker.track)('websiteNavigationInteraction', {
            action: 'clicked-view-blog-link'
          });
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: buttonLangKey('viewBlog')
      }));
    }
  }, {
    key: "renderBlogActions",
    value: function renderBlogActions() {
      return _react.default.createElement(_UIMultiColumnItem.default, {
        horizontalAlign: "right"
      }, this.renderViewBlogLink(), this.renderDeleteButton());
    }
  }, {
    key: "renderSingularBlogControls",
    value: function renderSingularBlogControls() {
      var selectedBlog = this.props.selectedBlog;
      return _react.default.createElement(_UIMultiColumnGroup.default, null, _react.default.createElement(_UIMultiColumnItem.default, {
        horizontalAlign: "left",
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: "marketing.blog.inputLabels.modifyBlog"
        })
      }, _react.default.createElement("p", null, selectedBlog.get('name'))), this.renderBlogActions());
    }
  }, {
    key: "renderMultipleBlogControls",
    value: function renderMultipleBlogControls() {
      var _this$props = this.props,
          blogOptions = _this$props.blogOptions,
          selectedBlog = _this$props.selectedBlog;
      return _react.default.createElement(_UIMultiColumnGroup.default, null, _react.default.createElement(_UIMultiColumnItem.default, {
        horizontalAlign: "left",
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: "marketing.blog.inputLabels.selectBlog"
        })
      }, _react.default.createElement(_UIFormControl.default, null, _react.default.createElement(_UISelect.default, {
        className: "p-all-0",
        buttonUse: "transparent",
        menuWidth: "auto",
        "data-test-id": "blog-select-dropdown",
        onChange: this.props.onSelectedBlogChange,
        options: blogOptions,
        value: selectedBlog.get('id')
      }))), this.renderBlogActions());
    }
  }, {
    key: "renderTab",
    value: function renderTab(tabKey) {
      return _react.default.createElement(_UITab.default, {
        className: "blog-tabs-" + tabKey,
        tabId: tabKey === 'general' ? 'default' : tabKey,
        title: _react.default.createElement(_FormattedMessage.default, {
          message: buttonLangKey(tabKey)
        })
      });
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      var activeTab = this.props.activeTab;
      return _react.default.createElement(_UITabs.default, {
        use: "enclosed",
        selected: activeTab,
        onSelectedChange: this.props.onSelectedTabChange,
        className: "blog-tabs m-bottom-10"
      }, this.renderTab('general'), this.renderTab('templates'), this.renderTab('subscriptions'), this.renderTab('dateFormats'), this.renderTab('comments'), this.renderTab('socialSharing'), this.renderTab('googleAmp'));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement(_UISubheader.default, {
        use: "condensed",
        className: "m-bottom-0",
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "marketing.links.blog"
        })
      }, _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        size: "small",
        href: this.props.blogImporterRoute,
        disabled: this.props.readOnly
      }, _react.default.createElement(_FormattedMessage.default, {
        message: buttonLangKey('importBlog')
      })), _react.default.createElement(_UIButton.default, {
        use: "tertiary",
        size: "small",
        "data-test-id": "create-blog-btn",
        onClick: this.props.onCreateBlog,
        disabled: this.props.readOnly
      }, _react.default.createElement(_FormattedMessage.default, {
        message: buttonLangKey('createBlog')
      }))), _react.default.createElement(_UIMultiColumn.default, {
        className: "m-bottom-10"
      }, this.renderBlogControls()), this.renderTabs());
    }
  }]);
  return BlogSettingsHeader;
}(_react.PureComponent);

BlogSettingsHeader.propTypes = {
  readOnly: _react.PropTypes.bool.isRequired,
  blogOptions: _react.PropTypes.array.isRequired,
  moreThanOneBlog: _react.PropTypes.bool.isRequired,
  selectedBlog: _react.PropTypes.instanceOf(_Blog.default).isRequired,
  activeTab: _react.PropTypes.string.isRequired,
  onDeleteBlog: _react.PropTypes.func.isRequired,
  onCreateBlog: _react.PropTypes.func.isRequired,
  onSelectedTabChange: _react.PropTypes.func.isRequired,
  onSelectedBlogChange: _react.PropTypes.func.isRequired,
  blogImporterRoute: _react.PropTypes.string.isRequired
};
var _default = BlogSettingsHeader;
exports.default = _default;
module.exports = exports.default;